import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import MediaList from '@/components/media-list'
import RichText from '@/components/rich-text'
import {Text} from '@/components/text'
import type {ContentPlusBlocksSliceFragment, ContentPlusBlocksFragment} from '@/graphql-types'
import {Section, BackgroundWrapper, Layout} from '@/styles/grid'
import {isValidBackgroundColor} from '@/utils/is-valid-background-color'

type Props = {
    slice: ContentPlusBlocksSliceFragment | ContentPlusBlocksFragment
}

export const ContentPlusBlocksSlice = React.forwardRef<HTMLDivElement, Props>(({slice}, ref) => {
    const color = isValidBackgroundColor(slice.primary.background)
        ? slice.primary.background
        : 'default'

    return (
        <BackgroundWrapper ref={ref} $color={color}>
            <Layout as={Section} $variant="two-asymmetrical">
                <HeaderWrapper>
                    <Text $variant="heading-base">{slice.primary.plainTitle}</Text>
                    <RichText content={slice.primary.text_under_title.richText} />
                </HeaderWrapper>

                <MediaList
                    items={slice.items.map((item) => ({
                        ...item,
                        title: item.block_title,
                        body: item.block_content.richText,
                        image: item.block_image?.url ? item.block_image : undefined,
                    }))}
                />
            </Layout>
        </BackgroundWrapper>
    )
})

export const HeaderWrapper = styled.div`
    display: grid;
    align-content: start;
    gap: ${({theme}) => theme.spacings.s20};
`

export const contentPlusBlocksSliceFragment = graphql`
    fragment ContentPlusBlocksSlice on PrismicSlicePageDataBodyContentPlusBlocks {
        __typename
        primary {
            background
            plainTitle: title
            text_under_title {
                richText
            }
        }
        items {
            block_image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
            }
            block_title
            block_content {
                richText
            }
        }
    }
`
